import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de2024fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { class: "summary-time" }
const _hoisted_3 = { style: {"margin-right":"10px"} }
const _hoisted_4 = { style: {"margin-right":"10px"} }
const _hoisted_5 = { style: {"margin-right":"10px"} }
const _hoisted_6 = { style: {"margin-right":"10px"} }
const _hoisted_7 = { style: {"margin-right":"10px"} }
const _hoisted_8 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  style: {"margin-right":"10px"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { style: {"clear":"both","float":"left"} }
const _hoisted_16 = { style: {"margin-left":"20px"} }
const _hoisted_17 = {
  key: 1,
  style: {"margin-left":"20px"}
}
const _hoisted_18 = {
  key: 2,
  title: "订单的应收账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_19 = {
  key: 3,
  title: "委托书的应收账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_20 = { style: {"float":"left","margin-left":"10px"} }
const _hoisted_21 = { style: {"float":"right"} }
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_24 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_25 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_26 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_27 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_28 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_29 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_30 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_31 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_32 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_36 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_37 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_42 = { style: {"float":"left"} }
const _hoisted_43 = { style: {"margin-left":"20px"} }
const _hoisted_44 = {
  key: 1,
  style: {"margin-left":"20px"}
}
const _hoisted_45 = {
  key: 2,
  title: "订单的应付账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_46 = {
  key: 3,
  title: "委托书的应付账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_47 = { style: {"float":"right"} }
const _hoisted_48 = ["title"]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"5px"} }, "已分摊", -1))
const _hoisted_52 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_53 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden"}
}
const _hoisted_56 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_57 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_58 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_59 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_60 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_64 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_65 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_70 = { style: {"float":"left"} }
const _hoisted_71 = { style: {"margin-left":"20px"} }
const _hoisted_72 = {
  key: 1,
  style: {"margin-left":"20px"}
}
const _hoisted_73 = {
  key: 2,
  title: "订单的结算价账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_74 = {
  key: 3,
  title: "委托书的结算价账单已被锁定",
  style: {"color":"red","font-weight":"900","margin-inline":"5px"}
}
const _hoisted_75 = { style: {"float":"right"} }
const _hoisted_76 = ["title"]
const _hoisted_77 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_78 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_79 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_80 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_81 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_82 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_83 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_84 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_87 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_88 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_90 = { style: {"float":"right"} }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { style: {"font-size":"13px"} }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { style: {"float":"left"} }
const _hoisted_95 = { style: {"font-weight":"900"} }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_98 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_100 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_101 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_102 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_103 = {
  key: 0,
  style: {}
}
const _hoisted_104 = { key: 0 }
const _hoisted_105 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_106 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_107 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_108 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_109 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_110 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_111 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_112 = { style: {} }
const _hoisted_113 = ["onClick"]
const _hoisted_114 = ["onClick"]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_119 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_120 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_121 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_122 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_123 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_124 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_125 = { style: {} }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = ["onClick"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_129 = { key: 1 }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_131 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_132 = { key: 0 }
const _hoisted_133 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_134 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_135 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_136 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_137 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_138 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_139 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_140 = { style: {} }
const _hoisted_141 = { key: 1 }
const _hoisted_142 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_143 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_144 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_145 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_146 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_147 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_148 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_149 = { style: {"font-weight":"900","color":"red"} }
const _hoisted_150 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_151 = { style: {} }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_154 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"40px"} }, null, -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 发票信息 ", -1))
const _hoisted_157 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_158 = { key: 0 }
const _hoisted_159 = { key: 1 }
const _hoisted_160 = { key: 2 }
const _hoisted_161 = ["title"]
const _hoisted_162 = ["title"]
const _hoisted_163 = ["title"]
const _hoisted_164 = ["title"]
const _hoisted_165 = { key: 1 }
const _hoisted_166 = ["title"]
const _hoisted_167 = ["title"]
const _hoisted_168 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_169 = { key: 0 }
const _hoisted_170 = ["onClick"]
const _hoisted_171 = { key: 1 }
const _hoisted_172 = ["title"]
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_174 = { style: {"clear":"both"} }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销信息 ", -1))
const _hoisted_176 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_177 = { style: {"width":"100% !important"} }
const _hoisted_178 = { key: 0 }
const _hoisted_179 = { key: 1 }
const _hoisted_180 = {
  key: 2,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","margin-left":"10px"}
}
const _hoisted_181 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_182 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_183 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_184 = ["title"]
const _hoisted_185 = ["title"]
const _hoisted_186 = ["title"]
const _hoisted_187 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_188 = { key: 0 }
const _hoisted_189 = { key: 1 }
const _hoisted_190 = ["title"]
const _hoisted_191 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_192 = ["title"]
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_194 = { style: {"float":"right"} }
const _hoisted_195 = { key: 0 }
const _hoisted_196 = { style: {"font-size":"13px"} }
const _hoisted_197 = ["onClick"]
const _hoisted_198 = { style: {"float":"left"} }
const _hoisted_199 = { style: {"font-weight":"900"} }
const _hoisted_200 = { key: 0 }
const _hoisted_201 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_202 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_204 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_205 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_206 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_207 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_208 = {
  key: 0,
  style: {}
}
const _hoisted_209 = { key: 0 }
const _hoisted_210 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_211 = { style: {"font-weight":"900"} }
const _hoisted_212 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_213 = { style: {"font-weight":"900"} }
const _hoisted_214 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_215 = { style: {"font-weight":"900"} }
const _hoisted_216 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_217 = { style: {} }
const _hoisted_218 = ["onClick"]
const _hoisted_219 = ["onClick"]
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_221 = { key: 1 }
const _hoisted_222 = { key: 0 }
const _hoisted_223 = { key: 1 }
const _hoisted_224 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_225 = { style: {"font-weight":"900"} }
const _hoisted_226 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_227 = { style: {"font-weight":"900"} }
const _hoisted_228 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_229 = { style: {"font-weight":"900"} }
const _hoisted_230 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_231 = { style: {} }
const _hoisted_232 = ["onClick"]
const _hoisted_233 = ["onClick"]
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_235 = { key: 1 }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_237 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_238 = { key: 0 }
const _hoisted_239 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_240 = { style: {"font-weight":"900"} }
const _hoisted_241 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_242 = { style: {"font-weight":"900"} }
const _hoisted_243 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_244 = { style: {"font-weight":"900"} }
const _hoisted_245 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_246 = { style: {} }
const _hoisted_247 = { key: 1 }
const _hoisted_248 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_249 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_250 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_251 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_252 = { style: {"font-weight":"900"} }
const _hoisted_253 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_254 = { style: {"font-weight":"900"} }
const _hoisted_255 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_256 = { style: {"font-weight":"900"} }
const _hoisted_257 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_258 = { style: {} }
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_261 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_263 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, {
      center: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "提单号码：" + _toDisplayString(_ctx.isString(_ctx.dto.BLNO)), 1),
          _createElementVNode("span", _hoisted_4, "舱单截止时间：" + _toDisplayString(_ctx.formatTime(_ctx.dto?.ManifestEndDate)), 1),
          _createElementVNode("span", _hoisted_5, "截关时间：" + _toDisplayString(_ctx.formatTime(_ctx.dto?.CustomsEndDate)), 1),
          _createElementVNode("span", _hoisted_6, "开港时间：" + _toDisplayString(_ctx.formatTime(_ctx.dto?.OpenPortDate)), 1),
          _createElementVNode("span", _hoisted_7, "截港时间：" + _toDisplayString(_ctx.formatTime(_ctx.dto?.PortEndDate)), 1),
          ((_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewAccountsReceivable==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsReceivable==true) && (_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewAccountsPayable==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsPayable==true))
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createTextVNode(" 毛利润： "),
                (_ctx.dto.GrossProfits.length>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.dto.SumGrossProfit), 1),
                      _createTextVNode(" ( "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dto.GrossProfits, (p, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          style: _normalizeStyle(p.Price<0?'color:red':'')
                        }, _toDisplayString(p.CurrencySystemCode) + _toDisplayString(p.Price) + "  ", 5))
                      }), 128)),
                      _createTextVNode(" ) ")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          ((_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewAccountsReceivable==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsReceivable==true) && (_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewSettlement==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewSettlementPrice==true))
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createTextVNode(" 结算利润： "),
                (_ctx.dto.SalerProfits.length>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.dto.SumSalerProfit), 1),
                      _createTextVNode(" ( "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dto.SalerProfits, (p, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          style: _normalizeStyle(p.Price<0?'color:red':'')
                        }, _toDisplayString(p.CurrencySystemCode) + _toDisplayString(p.Price) + "  ", 5))
                      }), 128)),
                      _createTextVNode(" ) ")
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (_ctx.dto.OrderStatus == 40)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "（已取消）"))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewAccountsReceivable==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsReceivable==true)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          style: {"background-color":"#fff0f5"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isCollection = !_ctx.isCollection))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(" 应收账单"),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.dto.Collection), 1),
                (_ctx.dto.Code!=null && _ctx.dto.Code!=undefined && _ctx.dto.Code!='')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"margin-left":"20px","color":"#fe995b","cursor":"pointer"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOrder(10)))
                    }, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1)),
                (_ctx.dto.IsCollectionOrder==true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Lock)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.dto.IsCollectionPool==true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.dto.IsDepartureChargeWeight == true)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDepartureChargeWeight()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("入库计费重量/体积")
                      ]),
                      _: 1
                    }))
                  : (_ctx.dto.IsDestinationChargeWeight == true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDestinationChargeWeight()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("入库计费重量/体积")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_ctx.isCollection==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.isCollection==false)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  script: "",
                  border: "",
                  "row-class-name": _ctx.tableRowClassName,
                  data: _ctx.dto.Collections,
                  ref: "collectionBillTable",
                  style: {"margin-top":"15px"},
                  "header-cell-style": { 'text-align': 'left' },
                  "cell-style": { 'text-align': 'left' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.IsSave",
                      label: "",
                      width: "30px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.IsSave == true)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              style: {"color":"forestgreen"},
                              title: "账单已提交"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Check)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Pool",
                      label: "Booking No",
                      width: "180px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Pool)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle([{"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}, scope.row.IsPoolCancel==true?'color:red;':'']),
                              title: scope.row.IsPoolCancel==true?'委托书已取消':''
                            }, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo,scope.row)), 13, _hoisted_22))
                          : (_openBlock(), _createElementBlock("div", _hoisted_23, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.ClientLabel",
                      label: "对账对象",
                      width: "250px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.ClientLabel)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.isString(scope.row.ClientLabel,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CostId",
                      label: "费用名称",
                      width: "200px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Cost!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.isString(scope.row.Cost.FullName,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CurrencySystem",
                      label: "币制",
                      width: "60px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.CurrencySystem!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.UnitPrice",
                      label: "单价",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.isNumber(scope.row.UnitPrice,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.currencySystem?.ShowTaxRate)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          prop: "scope.row.TaxRate",
                          label: "税率%",
                          width: "100px",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.isString(scope.row.TaxRate,scope.row)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitId",
                      label: "计价单位",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_32, [
                          (scope.row.FirstChargeUnit!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.FullName,scope.row)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_34, "暂无数据"))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitNumber",
                      label: "数量",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.currencySystem?.ShowTaxRate)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          prop: "scope.row.TaxAmount",
                          label: "税额",
                          width: "120px",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.isNumber(scope.row.TaxAmount,scope.row)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.TotalPrice",
                      label: "单项合计",
                      width: "120px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"},
                          class: _normalizeClass(((parseFloat((scope?.row?.UnitPrice??0) * (scope?.row?.FirstChargeUnitNumber??0) + (scope?.row?.TaxAmount ?? 0)).toFixed(2) != parseFloat(scope?.row?.TotalPrice??0).toFixed(2))?'red':''))
                        }, _toDisplayString(_ctx.isNumber(scope.row.TotalPrice,scope.row)), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Remark",
                      label: "备注",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.isString(scope.row.Remark,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.InvoiceNumber",
                      label: "发票号码",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.InvoiceNumber!=null && scope.row.InvoiceNumber!=undefined && scope.row.InvoiceNumber !='' && scope.row.InvoiceNumber !='暂无数据')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.onInvoice(scope.row)),
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                            }, _toDisplayString(_ctx.isString(scope.row.InvoiceNumber,scope.row)), 9, _hoisted_38))
                          : (_openBlock(), _createElementBlock("div", _hoisted_39, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.SettlementTypeString",
                      label: "核销状态",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.onSettlement(scope.row)),
                          style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                        }, _toDisplayString(_ctx.isString(scope.row.SettlementTypeString,scope.row)), 9, _hoisted_40)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Code",
                      label: "账单编号",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.isString(scope.row.Code,scope.row)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["row-class-name", "data"]))
              : _createCommentVNode("", true),
            _createVNode(_component_miezz_upload, {
              modelValue: _ctx.filesCollection.Files,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filesCollection.Files) = $event)),
              path: "order/bill/file",
              prop: "File",
              maxSize: 2 * 1024 * 1024,
              preview: !(_ctx.id && _ctx.power.contains('OrderManagement_Pool_Summary_BillingInformation_EditAP')
            || _ctx.orderId && _ctx.power.contains('OrderManagement_Order_Summary_BillingInformation_EditAP'))
            }, null, 8, ["modelValue", "preview"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.OrderManagement_Pool_Summary_BillingInformation_ViewAccountsPayable==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewAccountsPayable==true)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 1,
          style: {"margin-top":"5px","background-color":"#e2f1f8"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isPayment = !_ctx.isPayment))
            }, [
              _createElementVNode("div", _hoisted_42, [
                _createTextVNode(" 应付账单"),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.dto.Payment), 1),
                (_ctx.dto.Code!=null && _ctx.dto.Code!=undefined && _ctx.dto.Code!='')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"margin-left":"20px","color":"#fe995b","cursor":"pointer"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOrder(20)))
                    }, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1)),
                (_ctx.dto.IsPaymentOrder==true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Lock)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.dto.IsPaymentPool==true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.dto.IsPaymentTask == true)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 4,
                      type: "primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onFinishTask())),
                      size: "small",
                      style: {"margin-left":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("关闭待办")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_ctx.isPayment==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.isPayment==false)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  script: "",
                  border: "",
                  "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
                  "row-key": "Id",
                  "default-expand-all": false,
                  "row-class-name": _ctx.tableRowClassName,
                  data: _ctx.dto.Payments,
                  ref: "paymentBillTable",
                  style: {"width":"100%","margin-top":"15px"},
                  "header-cell-style": { 'text-align': 'left' },
                  "cell-style": { 'text-align': 'left' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.IsSave",
                      label: "",
                      width: "30px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.IsSave == true)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              style: {"color":"forestgreen"},
                              title: "账单已提交"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Check)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Pool",
                      label: "Booking No",
                      width: "180px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Pool)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: _normalizeStyle([{"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}, scope.row.IsPoolCancel==true?'color:red;':'']),
                              title: scope.row.IsPoolCancel==true?'委托书已取消':''
                            }, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo,scope.row)), 13, _hoisted_48))
                          : (scope.row.Child==null || scope.row.Child==undefined || scope.row.Child.length<=0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_49, " 未分摊 "))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden"},
                                onClick: ($event: any) => (_ctx.onChild(scope.row))
                              }, [
                                (scope.row.IsOpen == false)
                                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Minus)
                                      ]),
                                      _: 1
                                    })),
                                _hoisted_51
                              ], 8, _hoisted_50))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.SupplierLabel",
                      label: "对账对象",
                      width: "250px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.isString(scope.row.SupplierLabel,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CostId",
                      label: "费用名称",
                      width: "200px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Cost!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createTextVNode(_toDisplayString(scope.row.Cost.FullName), 1),
                              (scope.row.FromId!=undefined)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "分摊"))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_55, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CurrencySystem",
                      label: "币制",
                      width: "60px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Cost!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_57, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.UnitPrice",
                      label: "单价",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.isNumber(scope.row.UnitPrice,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.currencySystem?.ShowTaxRate)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          prop: "scope.row.TaxRate",
                          label: "税率%",
                          width: "100px",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.isString(scope.row.TaxRate,scope.row)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitId",
                      label: "计价单位",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_60, [
                          (scope.row.FirstChargeUnit!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.FullName,scope.row)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitId,scope.row)), 1))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitNumber",
                      label: "数量",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.currencySystem?.ShowTaxRate)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 1,
                          prop: "scope.row.TaxAmount",
                          label: "税额",
                          width: "120px",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.isNumber(scope.row.TaxAmount,scope.row)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.TotalPrice",
                      label: "单项合计",
                      width: "120px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"},
                          class: _normalizeClass(((parseFloat((scope?.row?.UnitPrice??0) * (scope?.row?.FirstChargeUnitNumber??0) + (scope?.row?.TaxAmount ?? 0)).toFixed(2) != parseFloat(scope?.row?.TotalPrice??0).toFixed(2))?'red':''))
                        }, _toDisplayString(_ctx.isNumber(scope.row.TotalPrice,scope.row)), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Remark",
                      label: "备注",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.isString(scope.row.Remark,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.InvoiceNumber",
                      label: "发票号码",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.InvoiceNumber!=null && scope.row.InvoiceNumber!=undefined && scope.row.InvoiceNumber !='' && scope.row.InvoiceNumber !='暂无数据')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.onInvoice(scope.row)),
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                            }, _toDisplayString(_ctx.isString(scope.row.InvoiceNumber,scope.row)), 9, _hoisted_66))
                          : (_openBlock(), _createElementBlock("div", _hoisted_67, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.SettlementTypeString",
                      label: "核销状态",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.onSettlement(scope.row)),
                          style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                        }, _toDisplayString(_ctx.isString(scope.row.SettlementTypeString,scope.row)), 9, _hoisted_68)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Code",
                      label: "账单编号",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.isString(scope.row.Code,scope.row)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["row-class-name", "data"]))
              : _createCommentVNode("", true),
            _createVNode(_component_miezz_upload, {
              modelValue: _ctx.files.Files,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.files.Files) = $event)),
              path: "order/bill/file",
              prop: "File",
              maxSize: 2 * 1024 * 1024,
              preview: !(_ctx.id && _ctx.power.contains('OrderManagement_Pool_Summary_BillingInformation_EditAP')
            || _ctx.orderId && _ctx.power.contains('OrderManagement_Order_Summary_BillingInformation_EditAP'))
            }, null, 8, ["modelValue", "preview"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.dto.IsSaler == true && _ctx.OrderManagement_Pool_Summary_BillingInformation_ViewSettlement==true || _ctx.OrderManagement_Order_Summary_BillingInformation_ViewSettlementPrice==true)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 2,
          style: {"margin-top":"5px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isSaler = !_ctx.isSaler))
            }, [
              _createElementVNode("div", _hoisted_70, [
                _createTextVNode(" 业务员结算账单"),
                _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.dto.Saler), 1),
                (_ctx.dto.Code!=null && _ctx.dto.Code!=undefined && _ctx.dto.Code!='')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"margin-left":"20px","color":"#fe995b","cursor":"pointer"},
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onOrder()))
                    }, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_72, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1)),
                (_ctx.dto.IsSalerOrder==true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Lock)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.dto.IsSalerPool==true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_75, [
                (_ctx.isSaler==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.isSaler==false)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  script: "",
                  border: "",
                  "row-class-name": _ctx.tableRowClassName,
                  data: _ctx.dto.Salers,
                  ref: "salerBillTable",
                  style: {"width":"100%","margin-top":"15px"},
                  "header-cell-style": { 'text-align': 'left' },
                  "cell-style": { 'text-align': 'left' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Pool",
                      label: "Booking No",
                      width: "180px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Pool)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle([{"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}, scope.row.IsPoolCancel==true?'color:red;':'']),
                              title: scope.row.IsPoolCancel==true?'委托书已取消':''
                            }, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo,scope.row)), 13, _hoisted_76))
                          : (_openBlock(), _createElementBlock("div", _hoisted_77, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.SalerNameLabel",
                      label: "业务员",
                      width: "250px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.isString(scope.row.SalerNameLabel,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CostId",
                      label: "费用名称",
                      width: "200px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Cost!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_80, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.CurrencySystem",
                      label: "币制",
                      width: "60px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.Cost!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_82, " 暂无数据 "))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.UnitPrice",
                      label: "单价",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.isNumber(scope.row.UnitPrice,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitId",
                      label: "计价单位",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_84, [
                          (scope.row.FirstChargeUnit!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.FullName,scope.row)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.FirstChargeUnitNumber",
                      label: "数量",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.TotalPrice",
                      label: "单项合计",
                      width: "120px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"},
                          class: _normalizeClass(((parseFloat((scope?.row?.UnitPrice??0) * (scope?.row?.FirstChargeUnitNumber??0) + (scope?.row?.TaxAmount ?? 0)).toFixed(2) != parseFloat(scope?.row?.TotalPrice??0).toFixed(2))?'red':''))
                        }, _toDisplayString(_ctx.isNumber(scope.row.TotalPrice,scope.row)), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Remark",
                      label: "备注",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.isString(scope.row.Remark,scope.row)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "scope.row.Code",
                      label: "账单编号",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.isString(scope.row.Code,scope.row)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["row-class-name", "data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onClickHistory()))
        }, [
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, [
            (_ctx.isHistory==false)
              ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDownBold)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowUpBold)
                  ]),
                  _: 1
                }))
          ])
        ]),
        (_ctx.isHistory==false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
              (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                        return (_openBlock(), _createBlock(_component_el_timeline_item, {
                          key: index,
                          timestamp: activity.CreatedTime,
                          "hide-timestamp": true
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", {
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                              }, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                  _createElementVNode("span", _hoisted_95, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                  _createTextVNode(_toDisplayString(activity.Title), 1),
                                  (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_96, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Plus)
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Minus)
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_99
                              ], 8, _hoisted_93),
                              (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                      return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                        (p.Title!=null && p.Title!=undefined && p.Title!='')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                              (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    style: _normalizeStyle([{"float":"left","text-indent":"20px"}, p.IsBold==true?'color:red;font-weight:900;':''])
                                                  }, _toDisplayString(p.Title), 5))
                                                : _createCommentVNode("", true),
                                              (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                    (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                            return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                              (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                                    (p2.State==4 && (index2==0 || p.IsOpen==true))
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                                          _createTextVNode("新增了"),
                                                                          _createElementVNode("span", _hoisted_106, _toDisplayString(p2.Label), 1),
                                                                          _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p2.State==3 && (index2==0 || p.IsOpen==true))
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                                          _createTextVNode("编辑了"),
                                                                          _createElementVNode("span", _hoisted_108, _toDisplayString(p2.Label), 1),
                                                                          _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p2.State==2 && (index2==0 || p.IsOpen==true))
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                                          _createTextVNode("删除了"),
                                                                          _createElementVNode("span", _hoisted_110, _toDisplayString(p2.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p2.State==999 && (index2==0 || p.IsOpen==true))
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                                                          _createElementVNode("span", _hoisted_112, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p.IsOpen==false && index2==0 && p.Child.length>1)
                                                                      ? (_openBlock(), _createElementBlock("div", {
                                                                          key: 4,
                                                                          onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                          style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                        }, [
                                                                          _createVNode(_component_el_icon, null, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_Plus)
                                                                            ]),
                                                                            _: 1
                                                                          })
                                                                        ], 8, _hoisted_113))
                                                                      : _createCommentVNode("", true),
                                                                    (p.IsOpen==true && index2==0 && p.Child.length>1)
                                                                      ? (_openBlock(), _createElementBlock("div", {
                                                                          key: 5,
                                                                          onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                          style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                        }, [
                                                                          _createVNode(_component_el_icon, null, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_Minus)
                                                                            ]),
                                                                            _: 1
                                                                          })
                                                                        ], 8, _hoisted_114))
                                                                      : _createCommentVNode("", true),
                                                                    _hoisted_115
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                                                    (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                      ? (_openBlock(), _createElementBlock("div", {
                                                                          key: 0,
                                                                          style: _normalizeStyle(p2.IsBold==true?'color:red;font-weight:900;':'')
                                                                        }, _toDisplayString(p2.Title), 5))
                                                                      : (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(p2.NewLabel), 1))
                                                                  ])),
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                  key: index3,
                                                                  style: {"line-height":"28px"}
                                                                }, [
                                                                  (p3.State==4 && (index3==0 || p2.IsOpen==true))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                                        _createTextVNode("新增了"),
                                                                        _createElementVNode("span", _hoisted_119, _toDisplayString(p3.Label), 1),
                                                                        _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (p3.State==3 && (index3==0 || p2.IsOpen==true))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                                        _createTextVNode("编辑了"),
                                                                        _createElementVNode("span", _hoisted_121, _toDisplayString(p3.Label), 1),
                                                                        _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (p3.State==2 && (index3==0 || p2.IsOpen==true))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                                                        _createTextVNode("删除了"),
                                                                        _createElementVNode("span", _hoisted_123, _toDisplayString(p3.Label), 1),
                                                                        _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (p3.State==999 && (index3==0 || p2.IsOpen==true))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                                                        _createElementVNode("span", _hoisted_125, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                        _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  (p2.IsOpen==false && index3==0 && p2.Child.length>1)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 4,
                                                                        onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                        style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                      }, [
                                                                        _createVNode(_component_el_icon, null, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_Plus)
                                                                          ]),
                                                                          _: 1
                                                                        })
                                                                      ], 8, _hoisted_126))
                                                                    : _createCommentVNode("", true),
                                                                  (p2.IsOpen==true && index3==0 && p2.Child.length>1)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 5,
                                                                        onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                        style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                      }, [
                                                                        _createVNode(_component_el_icon, null, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_Minus)
                                                                          ]),
                                                                          _: 1
                                                                        })
                                                                      ], 8, _hoisted_127))
                                                                    : _createCommentVNode("", true),
                                                                  _hoisted_128
                                                                ]))
                                                              }), 128))
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_129, "—"))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _hoisted_130
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                              (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                                    (p.State==4)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                                          _createTextVNode("新增了"),
                                                          _createElementVNode("span", _hoisted_134, _toDisplayString(p.Label), 1),
                                                          _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (p.State==3)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                                          _createTextVNode("编辑了"),
                                                          _createElementVNode("span", _hoisted_136, _toDisplayString(p.Label), 1),
                                                          _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (p.State==2)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                                          _createTextVNode("删除了"),
                                                          _createElementVNode("span", _hoisted_138, _toDisplayString(p.Label), 1),
                                                          _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (p.State==999)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                          _createElementVNode("span", _hoisted_140, "未编辑" + _toDisplayString(p.Label), 1),
                                                          _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                                    (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 0,
                                                          style: _normalizeStyle([{"float":"left","text-indent":"20px"}, p.IsBold==true?'color:red;font-weight:900;':''])
                                                        }, _toDisplayString(p.Title), 5))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_142, _toDisplayString(p.NewLabel), 1)),
                                                    _createElementVNode("div", _hoisted_143, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          style: {"clear":"both"},
                                                          key: index3
                                                        }, [
                                                          (p3.State==4)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                                                _createTextVNode("新增了"),
                                                                _createElementVNode("span", _hoisted_145, _toDisplayString(p3.Label), 1),
                                                                _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p3.State==3)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                                                _createTextVNode("编辑了"),
                                                                _createElementVNode("span", _hoisted_147, _toDisplayString(p3.Label), 1),
                                                                _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p3.State==2)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                                                _createTextVNode("删除了"),
                                                                _createElementVNode("span", _hoisted_149, _toDisplayString(p3.Label), 1),
                                                                _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p3.State==999)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_150, [
                                                                _createElementVNode("span", _hoisted_151, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      }), 128)),
                                                      _hoisted_152
                                                    ]),
                                                    _hoisted_153
                                                  ]))
                                            ]))
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["timestamp"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_154, " 暂无数据 ")),
              (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0 && _ctx.historys.Data.Total>_ctx.historys.Data.Items.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onMoreHistyory())),
                    style: {"text-align":"center","width":"100%","line-height":"24px","height":"24px","background-color":"#00a9fc","color":"#fff","font-size":"12px","cursor":"pointer"}
                  }, [
                    _createTextVNode(" 查看更多 "),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _hoisted_155
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      key: _ctx.btnKey,
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"])),
    (_ctx.invoiceForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 3,
          modelValue: _ctx.invoiceForm.Visiable,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.invoiceForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"70%"},
          top: "10px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_156,
            _createElementVNode("div", _hoisted_157, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                ref: "refInvoiceForm",
                model: _ctx.invoiceForm,
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    "label-width": "100px",
                    style: {"margin":"0px","padding":"0px"},
                    label: "账单合计"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.invoiceForm.BillString), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    "label-width": "100px",
                    style: {"margin":"0px","padding":"0px"},
                    label: "发票合计"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.invoiceForm.InvoiceString), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    "label-width": "100px",
                    label: "发票状态"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.invoiceForm.Status==30)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_158, "已添加"))
                        : (_ctx.invoiceForm.Status==20)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_159, "部分添加"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_160, "待添加"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    ref: "invoiceTable",
                    border: "",
                    script: "",
                    data: _ctx.invoiceForm.InvoiceItems
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "Number",
                        label: "发票号码"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.Number,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.Number), 9, _hoisted_161)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "CollectionTitle",
                        label: "收款方发票抬头"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.CollectionTitle,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.CollectionTitle), 9, _hoisted_162)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "PaymentTitle",
                        label: "付款方发票抬头"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.PaymentTitle,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.PaymentTitle), 9, _hoisted_163)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "CurrencySystemId",
                        width: "60",
                        label: "币制"
                      }, {
                        default: _withCtx((scope) => [
                          (scope.row.CurrencySystem!=null)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                title: scope.row.CurrencySystem.Code,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.CurrencySystem.Code), 9, _hoisted_164))
                            : (_openBlock(), _createElementBlock("div", _hoisted_165, " 暂无数据 "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Price",
                        width: "140",
                        label: "金额"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.Price,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.Price), 9, _hoisted_166)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "InvoiceDate",
                        width: "140",
                        label: "开票日期"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.InvoiceDateString,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.InvoiceDateString), 9, _hoisted_167)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Annexs",
                        width: "70",
                        label: "凭证"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_168, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                (scope.row.Annexs!=null && scope.row.Annexs!=undefined && scope.row.Annexs.length>0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_169, [
                                      _createElementVNode("span", {
                                        onClick: ($event: any) => (_ctx.onAnnex(scope.row.Annexs[0])),
                                        style: {"cursor":"pointer","font-size":"18px"}
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Document)
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_170)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_171, " 暂无数据 "))
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Remark",
                        label: "备注"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            title: scope.row.Remark,
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                          }, _toDisplayString(scope.row.Remark), 9, _hoisted_172)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _hoisted_173,
            _createElementVNode("div", _hoisted_174, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.invoiceBottomButtons,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.invoiceBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickInvoice
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.settlementForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          modelValue: _ctx.settlementForm.Visiable,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.settlementForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"90%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          top: "0px",
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_175,
            _createElementVNode("div", _hoisted_176, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_177, [
              _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "refSettlementForm",
                    model: _ctx.settlementForm,
                    rules: _ctx.settlementRules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "总金额",
                        style: {"margin-top":"0px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.Total)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "待核销",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.NoSettlementPrice)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "已核销",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.settlementForm.SettlementPrice!=null && _ctx.settlementForm.SettlementPrice!=undefined && _ctx.settlementForm.SettlementPrice!='')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_178, _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.SettlementPrice)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_179, _toDisplayString(_ctx.currencySystem?.CurrencySystemCode??"CNY") + "0", 1)),
                          (_ctx.settlementForm.NoSettlementPrice != 0 && _ctx.FinancialManagement_BillSummary_Writeoff==true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_180, [
                                _createElementVNode("span", {
                                  style: {"cursor":"pointer"},
                                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onAddSettlement && _ctx.onAddSettlement(...args)))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 添加")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_component_el_table, {
                        ref: "settlementTable",
                        key: _ctx.settlementTableRandom,
                        data: _ctx.settlementForm.Items
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "Price",
                            "show-overflow-tooltip": true,
                            label: "核销金额"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_181, _toDisplayString(scope.row.CurrencySystem.Code) + _toDisplayString(_ctx.formatNumber(scope.row.Price)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "DisplayRate",
                            width: "90px",
                            "show-overflow-tooltip": true,
                            label: "汇率"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.DisplayRate!=null && scope.row.DisplayRate!=undefined && scope.row.DisplayRate!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_182, _toDisplayString(scope.row.DisplayRate), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_183, " 1 "))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "SettlementDateString",
                            "show-overflow-tooltip": true,
                            label: "核销时间"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                title: scope.row.SettlementDateString,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.SettlementDateString), 9, _hoisted_184)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "CollectionTitle",
                            "show-overflow-tooltip": true,
                            label: "收款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                title: scope.row.CollectionTitle,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.CollectionTitle), 9, _hoisted_185)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "PaymentTitle",
                            "show-overflow-tooltip": true,
                            label: "付款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                title: scope.row.PaymentTitle,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.PaymentTitle), 9, _hoisted_186)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "Mode",
                            "show-overflow-tooltip": true,
                            label: "核销方式"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_187, [
                                (scope.row.Mode == 10)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_188, "对公银行"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_189, "现金/私人银行/其他"))
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "Remark",
                            "show-overflow-tooltip": true,
                            label: "备注"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                title: scope.row.Remark,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.Remark), 9, _hoisted_190)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "SettlementAnnexs",
                            "show-overflow-tooltip": true,
                            label: "凭证"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_191, [
                                _createVNode(_component_miezz_upload, {
                                  isTip: false,
                                  multiple: true,
                                  preview: true,
                                  modelValue: scope.row.SettlementAnnexs,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementAnnexs) = $event),
                                  path: "bill/file",
                                  accept: "file/*",
                                  prop: "Url",
                                  maxSize: 5 * 1024 * 1024
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" s "),
                          _createVNode(_component_el_table_column, {
                            prop: "CreatedUserName",
                            "show-overflow-tooltip": true,
                            label: "创建人"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                title: scope.row.CreatedUserName,
                                style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                              }, _toDisplayString(scope.row.CreatedUserName), 9, _hoisted_192)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]))
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, { style: {"margin-top":"5px","display":"none"} }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
                  }, [
                    _hoisted_193,
                    _createElementVNode("div", _hoisted_194, [
                      (_ctx.isHistory==false)
                        ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDownBold)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowUpBold)
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  (_ctx.isHistory==false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                        (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                          ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                    key: index,
                                    timestamp: activity.CreatedTime,
                                    "hide-timestamp": true
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_196, [
                                        _createElementVNode("div", {
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                        }, [
                                          _createElementVNode("div", _hoisted_198, [
                                            _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                            _createElementVNode("span", _hoisted_199, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                            _createTextVNode(_toDisplayString(activity.Title), 1),
                                            (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_200, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Plus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Minus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          _hoisted_203
                                        ], 8, _hoisted_197),
                                        (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                                return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                                  (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_206, _toDisplayString(p.Title), 1))
                                                          : _createCommentVNode("", true),
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                                              (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                      return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                        (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                                                              (p2.State==4 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                                                    _createTextVNode("新增了"),
                                                                                    _createElementVNode("span", _hoisted_211, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==3 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                                                    _createTextVNode("编辑了"),
                                                                                    _createElementVNode("span", _hoisted_213, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==2 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                                                                    _createTextVNode("删除了"),
                                                                                    _createElementVNode("span", _hoisted_215, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==999 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                                                                                    _createElementVNode("span", _hoisted_217, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==false && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 4,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Plus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_218))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==true && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 5,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Minus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_219))
                                                                                : _createCommentVNode("", true),
                                                                              _hoisted_220
                                                                            ]))
                                                                          : (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                                                              (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_222, _toDisplayString(p2.Title), 1))
                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_223, _toDisplayString(p2.NewLabel), 1))
                                                                            ])),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                          return (_openBlock(), _createElementBlock("div", {
                                                                            key: index3,
                                                                            style: {"line-height":"28px"}
                                                                          }, [
                                                                            (p3.State==4 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                                                                  _createTextVNode("新增了"),
                                                                                  _createElementVNode("span", _hoisted_225, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==3 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                                                  _createTextVNode("编辑了"),
                                                                                  _createElementVNode("span", _hoisted_227, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==2 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                                                  _createTextVNode("删除了"),
                                                                                  _createElementVNode("span", _hoisted_229, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==999 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                                                                                  _createElementVNode("span", _hoisted_231, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==false && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 4,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Plus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_232))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==true && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 5,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Minus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_233))
                                                                              : _createCommentVNode("", true),
                                                                            _hoisted_234
                                                                          ]))
                                                                        }), 128))
                                                                      ]))
                                                                    }), 128))
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_235, "—"))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _hoisted_236
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_237, [
                                                        (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                                                              (p.State==4)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                                                    _createTextVNode("新增了"),
                                                                    _createElementVNode("span", _hoisted_240, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==3)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                                                    _createTextVNode("编辑了"),
                                                                    _createElementVNode("span", _hoisted_242, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==2)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                                                    _createTextVNode("删除了"),
                                                                    _createElementVNode("span", _hoisted_244, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==999)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                                                                    _createElementVNode("span", _hoisted_246, "未编辑" + _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                                              (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_248, _toDisplayString(p.Title), 1))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_249, _toDisplayString(p.NewLabel), 1)),
                                                              _createElementVNode("div", _hoisted_250, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    style: {"clear":"both"},
                                                                    key: index3
                                                                  }, [
                                                                    (p3.State==4)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                                                          _createTextVNode("新增了"),
                                                                          _createElementVNode("span", _hoisted_252, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==3)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                                                          _createTextVNode("编辑了"),
                                                                          _createElementVNode("span", _hoisted_254, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==2)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                                                                          _createTextVNode("删除了"),
                                                                          _createElementVNode("span", _hoisted_256, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==999)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_257, [
                                                                          _createElementVNode("span", _hoisted_258, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                }), 128)),
                                                                _hoisted_259
                                                              ]),
                                                              _hoisted_260
                                                            ]))
                                                      ]))
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["timestamp"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_261, " 暂无数据 "))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _hoisted_262,
            _createElementVNode("div", _hoisted_263, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.settlementBottomButtons,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.settlementBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickSettlement
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}